import * as React from "react";

const SvgFadeIn = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.0867 3.44788C5.19235 2.83 5.02489 2.16401 4.59802 1.71611C3.96102 1.04774 2.98757 1.11808 2.42377 1.87322C1.85997 2.62837 1.9193 3.78235 2.5563 4.45072C2.98326 4.8987 3.56136 5.01482 4.06596 4.8153L11.2947 12.4001C11.189 13.0181 11.3565 13.6842 11.7834 14.1321C12.4204 14.8005 13.3938 14.7301 13.9576 13.975C14.5214 13.2199 14.4621 12.0659 13.8251 11.3975C13.3982 10.9496 12.8202 10.8334 12.3157 11.0328L5.0867 3.44788Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgFadeIn;
